
export class SolicitudCpeAnulacionViewModel {
    public Id: number;
    public IdEstadoSolicitudCpe: number = 0;
    public IdEstadoSolicitudCpeDescripcion: string;
    public Codigo: string;
    public TAnulacionCertificadoPrevioEx: TAnulacionCpeViewModel;
}
export class TAnulacionCpeViewModel {
    public Id: number;
    public IdCertPrevioEx: number;
    public IdUsuario: number;
    public NombreUsuario: string = '';;
    public Observaciones: string = '';;
    public Fecha: Date;
}














